module.exports = __webpack_public_path__ + "img/savings-rate.4378ca39.svg";